/**
 * Reports store
 */

import { create } from 'zustand';
import { Report, ReportJobStatus } from '../types/api';

interface ReportsState {
  reports: Report[];
  activeJobs: Map<string, ReportJobStatus>;
  
  setReports: (reports: Report[]) => void;
  addReport: (report: Report) => void;
  updateJobStatus: (jobId: string, status: ReportJobStatus) => void;
  removeJob: (jobId: string) => void;
}

export const useReportsStore = create<ReportsState>((set) => ({
  reports: [],
  activeJobs: new Map(),
  
  setReports: (reports) => set({ reports }),
  
  addReport: (report) => set((state) => ({
    reports: [report, ...state.reports],
  })),
  
  updateJobStatus: (jobId, status) => set((state) => {
    const newMap = new Map(state.activeJobs);
    newMap.set(jobId, status);
    return { activeJobs: newMap };
  }),
  
  removeJob: (jobId) => set((state) => {
    const newMap = new Map(state.activeJobs);
    newMap.delete(jobId);
    return { activeJobs: newMap };
  }),
}));


